export enum UserPreferenceMeasurements {
  Metric = "metric",
  Imperial = "imperial",
}
